import React, { Fragment } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from "styled-components";

// @ts-ignore
import { CWBLoadingCrest, CWBAPI } from "cwb-react";
// @ts-ignore
import { setUserAuthToken, setUserInfo } from "cwb-react";
// @ts-ignore
import { getCurUser, moment, getSessionDataFromAuthToken } from "cwb-react";
import imageSrc from "./images/icon-cwb-logo-grey.svg";
import Routes from "./Routes";
import Title from "./components/Common/Title";

// @ts-ignore
import CWBRTheme from "./Theme/CWBRSTheme";
import { client } from "./shared/apiClient";
import i18n from "./i18n";
import { language_code, setBrowserLang } from "./helpers";
import { withI18n } from "react-i18next";
import { connect } from "react-redux";

import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./Theme/custom-toast.css";

const qs = require("qs");

// const store = init();

let localApiPromise = import(`./shared/api/${process.env.CWB_API_FILE}`);
let sharedApiPromise = import(`cwb-react/dist/${process.env.CWB_API_FILE}`);

interface IProps extends StateProps, DispatchProps { }

interface IState {
  loading: boolean;
}

class App extends React.Component<IProps, IState> {
  public state: IState = {
    loading: true,
  };

  hotJarScript = document.createElement("script");

  async componentWillMount() {
    // console.log(process.env);

    toast.configure({
      toastClassName: "toaster--success",
      bodyClassName: "toaster-body",
      autoClose: 2000,
      hideProgressBar: true,
      position: "top-right",
    });

    const isProdOrStaging = process.env.REACT_APP_API === "production" ||
      process.env.REACT_APP_API === "staging";
    const baseName = isProdOrStaging
      ? process.env.PUBLIC_URL
      : process.env.REACT_APP_BaseName;

    let localApi = await localApiPromise;
    let sharedApi = await sharedApiPromise;
    const setup = { ...sharedApi.default, ...localApi.default };

    // Setup the globally accessible API client
    client.api = new CWBAPI(setup, process.env.CWB_API_ENV, process.env.CWB_USE_MOCK_ENV);
    let authToken = undefined;
    try {
      const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      let tokenResp;
      if (query.k) {
        try {
          tokenResp = await client.api.user.postBridgeAuthTokenFromSession(query.k);
        } catch (attempt) {
          tokenResp = await client.api.user.getAuthToken();
        }
      } else {
        try {
          tokenResp = await client.api.user.getAuthToken();
        } catch (attempt) {
          tokenResp = await client.api.user.getAuthTokenFromWebSession();
        }
      }

      authToken = tokenResp && tokenResp.data && tokenResp.data.accessToken;
      await setUserAuthToken(authToken);

      if (authToken) {
        const currentUser = getCurUser();
        if (currentUser) {
          const tokenData = getSessionDataFromAuthToken(authToken);
          const tokenUserId = tokenData
            ? (tokenData.UserId != null ? tokenData.UserId : tokenData.userId)
            : undefined;
          const tokenUserType = tokenData
            ? (tokenData.UserType != null ? tokenData.UserType : tokenData.userType)
            : undefined;
          const mismatch =
            (tokenUserId != null &&
              String(currentUser.id.userId) !== String(tokenUserId)) ||
            (tokenUserType != null &&
              String(currentUser.id.userTypeId) !== String(tokenUserType));
          if (mismatch) {
            setUserInfo(null);
          }
        }
      }

      const curUserInfoResp = await client.api.user.getCurrentUser();
      setUserInfo(curUserInfoResp.data);
      this.props.setAuthenticatedUser(curUserInfoResp.data);
      const curUser = curUserInfoResp.data;
      if (language_code.hasOwnProperty(curUser.languageChoice)) {
        i18n.changeLanguage(language_code[curUser.languageChoice]);
        moment.moment.locale(language_code[curUser.languageChoice]);
      }
      if (window.location.pathname.indexOf("/actor/vd") == -1 &&
        baseName.includes("castingworkbook/kiosk") == false) {
        await this.props.prepareRequestData();
      }
    } catch (error) {
      console.log(error);
      await setUserAuthToken(null);
      await setUserInfo(null);
      this.props.setAuthenticatedUser(null);
      await setBrowserLang();
    }

    if (isProdOrStaging && baseName.includes("castingworkbook/kiosk")) {
      this.hotJarScript.src = "/castingworkbook/kiosk/hotjar-kiosk.js";
      this.hotJarScript.async = true;
      document.body.appendChild(this.hotJarScript);
    }

    this.setState({ loading: false });
  }

  async componentWillUnmount() {
    try {
      document.body.removeChild(this.hotJarScript);
    } catch (e) { }
  }

  public render() {
    const routes = Routes();
    const baseName =
      process.env &&
        (process.env.REACT_APP_API === "production" ||
          process.env.REACT_APP_API === "staging")
        ? process.env.PUBLIC_URL
        : process.env.REACT_APP_BaseName;
    return (
      <ThemeProvider theme={CWBRTheme}>
        <Fragment>
          <Title documentTitle={this.props.documentTitle} />
          {this.state.loading && <CWBLoadingCrest customLogoSrc={imageSrc} />}
          {!this.state.loading && (
            <BrowserRouter basename={baseName}>
              <Switch>
                {React.Children.map(routes, child => {
                  return child as Route
                })}
                <Route
                  exact
                  path="/403"
                  render={() => {
                    window.location.replace(`${client.api.paths.redirect403}`);
                    return null;
                  }}
                />
                <Route
                  exact
                  path="/404"
                  render={() => {
                    window.location.replace(`${client.api.paths.redirect404}`);
                    return null;
                  }}
                />
                <Route
                  exact
                  path="/500"
                  render={() => {
                    window.location.replace(`${client.api.paths.redirect500}`);
                    return null;
                  }}
                />
                {<Redirect from="*" to="/404" />}
              </Switch>
            </BrowserRouter>
          )}
        </Fragment>
      </ThemeProvider>
    );
  }
}

interface StateProps {
  authenticatedUser: any;
  documentTitle: string;
}

const mapStateToProps = (state: any) => ({
  authenticatedUser: state.app.authenticatedUser,
  documentTitle: state.app.documentTitle
});

interface DispatchProps {
  prepareRequestData: () => boolean;
  setAuthenticatedUser: (authenticatedUser: any) => any;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    prepareRequestData: dispatch.scheduling.loadRequestData,
    setAuthenticatedUser: dispatch.app.setAuthenticatedUser
  };
}

export default withI18n()(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));
